import { render, staticRenderFns } from "./TrainingDatesList.vue?vue&type=template&id=8428d8d6&"
import script from "./TrainingDatesList.vue?vue&type=script&lang=js&"
export * from "./TrainingDatesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports